import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import "./configureAxios";

import store from "./store";

import App from "./components/App";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";


ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);
